import React from 'react';
import PropTypes from 'prop-types';
import './TextArea.css';
import { Box } from '@mui/material';
import Typography from '../Typography/Typography';
/**
 * @name CustomTextField
 * @param {object} props - required props in text field component
 * @returns {React.ReactElement} return the TextField Component
 */
const CustomTextArea = (props) => {
  const {
    label,
    onChange,
    type,
    value,
    disabled,
    error,
    pattern,
    errorMsg,
    customClass,
    requiredField,
    maxLength,
    id
  } = props;

  /**
   *
   * @returns {string} - returns the pattern regex
   */
  const patternValidation = () => {
    switch (pattern) {
      case 'email':
        return /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
      case 'number':
        return /^([0-9][0-9]{9,14})$/;
      case 'text':
        return /^[a-zA-Z ]*$/;
      default:
        return null;
    }
  };
  return (
    <Box>
      <Box>
        <Typography
          type="caption"
          text={label}
          customClass="labelText"
          colorType="senary"
          requiredField={requiredField}
        />
      </Box>
      <Box>
        <textarea
          id={id}
          type={type}
          value={value}
          error={error}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value, patternValidation(pattern))}
          className={`${error && 'errorBox'} inputBox  ${customClass} ${
            disabled && 'disable'
          }`}
          errorMsg={errorMsg}
          maxLength={maxLength}
          rows="3"
        />
        {error && <div className="errorBo">{errorMsg}</div>}
      </Box>
    </Box>
  );
};
export default CustomTextArea;
CustomTextArea.propTypes = {
  label: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  pattern: PropTypes.string,
  errorMsg: PropTypes.string,
  customClass: PropTypes.string,
  requiredField: PropTypes.bool,
  id: PropTypes.string
};
CustomTextArea.defaultProps = {
  onChange: () => {},
  type: 'text',
  disabled: false,
  error: false,
  label: '',
  maxLength: '',
  pattern: '',
  errorMsg: '',
  customClass: '',
  value: '',
  requiredField: false,
  id: ''
};
